<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <!--<div class="note">(*) Nội dung không được bỏ trống</div>-->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import formEdit from './add'
import ApiRepository from "@/core/ApiRepository";
//import firebase from "../../../../firebase.json";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Post",
      mode: 'add',
      models: {},
      images: [],
      oldImages: [],
      componentKey: 0,
      page_transaction:null
    }
  },
  async mounted () {
    console.log("this.$route.name:",this.$route.name);
    this.mode = this.$route.name === 'editPost' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Post' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_POST);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-post' });
    },
    convertPhone(numberPhone) {
      var phone = numberPhone
      if (numberPhone[0] === '0') {
        phone = phone.substring(1);
      }
      phone = phone.replace(' ', '')
      phone = '+84' + phone
      return phone
    },
    async saveData(params) {
      if (params !== undefined && Object.entries(params).length > 0) {
        var post_id = this.$route.params.id
        var type_post = params.type
        var objects = {
          'active' : params.active,
          // 'participation_fee': params.participation_fee,
          // 'currency_code' : params.currency_code,
          'title' : params.title,
          'caption' : params.caption,
          'plain_title' : this.$commonFuction.SkipVN(params.title),
          'plain_caption' : this.$commonFuction.SkipVN(params.caption),
          'abbout_club' : params.abbout_club,
        }
        var text_object = ''
        var text_query = ''
        let variables = {};
        if(type_post == 'LOOKING_FOR_A_TEAM'){
          objects.participation_fee = params.participation_fee
          objects.currency_code = params.currency_code
        }else if(type_post == 'SCOUT_CLUB_TEAM_MEMBER'){
          objects.participation_fee = params.participation_fee
          objects.currency_code = params.currency_code
          objects.schedule = params.schedule
          objects.number_recruit = params.number_recruit
          objects.gender = params.gender ? params.gender : null
          var post_operating_time = []
          if(params.post_operating_time && params.post_operating_time.length > 0){
            for (let i = 0; i < params.post_operating_time.length; i++) {
              post_operating_time.push({
                post_id : post_id,
                operating_time_id : params.post_operating_time[i].id
              })

            }
          }
          //post_operating_time
          text_object = `,$post_operating_time_objects: [post_operating_time_insert_input!]!`
          text_query = `
            delete_post_operating_time(where: { post_id: {_eq: "${post_id}"}}) {
              returning {
                id
              }
            }
            insert_post_operating_time(
              objects: $post_operating_time_objects
            ) {
              returning {
                id
              }
            }
          `
          variables['post_operating_time_objects'] = post_operating_time
        }else if(type_post == 'APPLYING_TO_JOIN'){
          objects.age = params.age ? params.age+'': ''
          objects.gender = params.gender ? params.gender : null
          objects.country_id = params.country_id
          objects.about_yourself = params.about_yourself ? params.about_yourself :''
          var post_operating_time_join = []
          if(params.post_operating_time && params.post_operating_time.length > 0){
            for (let i = 0; i < params.post_operating_time.length; i++) {
              post_operating_time_join.push({
                post_id : post_id,
                operating_time_id : params.post_operating_time[i].id
              })

            }
          }
          variables['post_operating_time_objects'] = post_operating_time_join
          var main_active_area = params.main_active_area ? params.main_active_area : [];
          var main_insert = []
          for (let i = 0; i < main_active_area.length; i++) {
            const e = main_active_area[i];
            main_insert.push({
              province_id : e.id,
              district_id : (e.is_all == false) ? e.district_id : null,
              post_id : post_id
            })
          }
          variables['post_main_area_object'] = main_insert
          text_object = `,$post_operating_time_objects: [post_operating_time_insert_input!]!,$post_main_area_object: [post_main_area_insert_input!]!`
          text_query = `
            delete_post_operating_time(where: { post_id: {_eq: "${post_id}"}}) {
              returning {
                id
              }
            }
            insert_post_operating_time(
              objects: $post_operating_time_objects
            ) {
              returning {
                id
              }
            }
            delete_post_main_area(where: { post_id: {_eq: "${post_id}"}}) {
              returning {
                id
              }
            }
            insert_post_main_area(
              objects: $post_main_area_object
            ) {
              returning {
                id
              }
            }
          `
        }else if(type_post == 'SHOWING_OFF_YOUR_EQUIPMENT'){
          var tags= params.tags ? params.tags : []
          var tag_text = ''
          var plain_tag = ''
          for (let tg = 0; tg < tags.length; tg++) {
            if(tg == 0){
              tag_text+= '#'+tags[tg].text
              plain_tag+= this.$commonFuction.SkipVN(tags[tg].text)
            }else{
              tag_text+= ' #'+tags[tg].text
              plain_tag+= ' '+this.$commonFuction.SkipVN(tags[tg].text)
            }
          }
          objects.tag = tag_text
          objects.plain_tag = plain_tag
        }


        variables['post_object'] = objects

        var that = this;
        var queryUpdate = `
            mutation update_post_multil($post_object: post_set_input`+text_object+`) {
              update_post(where: { id: {_eq: "${post_id}"}}, _set: $post_object) {
                affected_rows
                returning {
                  id
                }
              }
              `+text_query+`
            }
        `;

        
        that.$apollo.mutate({
          mutation: gql(queryUpdate),
          variables: variables
        }).then(async (res) => {
          console.log(res)
          /**Hình ảnh */
          var img_club_new = [];
          for (var im_g=0;im_g<params.img_club.length;im_g++){
            if (params.img_club[im_g].type !=='old_edit'){
              img_club_new.push(params.img_club[im_g]);
            }
          }
          var type_image = "";
          if(type_post =='POST_ON_MY_CLUB'){
            type_image = 'IMAGE_POST_MY_CLUB'
          }else if(type_post =='LOOKING_FOR_A_TEAM' || type_post =='LOOKING_FOR_MERCENARY' || type_post =='SCOUT_CLUB_TEAM_MEMBER' || type_post =='APPLYING_TO_JOIN'){
            type_image = 'IMAGE_POST_THE_MATCH'
          }else if(type_post =='MATCH' || type_post =='LIFE' || type_post =='SHOWING_OFF_YOUR_EQUIPMENT' || type_post =='QUESTION'){
            type_image = 'IMAGE_POST_COMMUNITY'
          }
          if(type_post == 'APPLYING_TO_JOIN'){
            ApiRepository.post(this.$constants.API.UPDATE_MAIN_ACTIVE_POST,{id : post_id})
          }
          if(type_image !== ''){
            //xóa hình cũ
            if(params.img_club_deleted.length > 0){
              await that.$CoreService.deleteDataImageMulti(type_image,params.img_club_deleted).then();
            }
            //thêm mới
            if (img_club_new.length > 0) {
              await that.$CoreService.uploadImages(that.$constants.FOLDER_S3.CLUB,img_club_new).then( async(resImage) => {
                if (resImage){
                  for (let t = 0; t < resImage.length; t++) {
                    var objectImage3  = resImage[t];//lấy 1 tấm hình
                    that.$CoreService.updateDataImage(type_image,post_id,objectImage3)
                  }
                }
                that.redirectEdit()
              });
            }else{
              that.redirectEdit()
            }
          }
        })
      }
    },
    async redirectEdit() {
      await this.$commonFuction.sleep(1000)
      var that = this;
      var router_back = {path: '/admin/list-post'};
      that.$commonFuction.is_loading(false);
      if (!that.$commonFuction.isEmpty(router_back)){
        router_back.query = { page_transaction: that.page_transaction.toString() };
      }
      that.$router.push(router_back);
      that.$toast.add({severity: 'success', summary: 'Notification', detail: 'Save success', life: 3000})
    },
    async uploadImagesOld(userID) {
      var s3client = Config.s3Client('user')
      if (this.images && userID) {
        //xoá avatar
        if (this.oldImages.length > 0) await this.deleteAvatar(s3client);

        this.$store.commit('setLoading', true);
        var objects = null;
        for (let index = 0; index < this.images.length; index++) {
          const img = this.images[index];
          let file = img.source
          if (file !== '' && img.file !== '') {
            let fileName = img.name;
            let random = Math.random().toString().slice(2);
            fileName = `${random}_${fileName}`
            await s3client.uploadFile(file, fileName).then((data) => {
              objects = data.location;
            });
          }
        }
        // console.log(objects);
        if (objects !== null) {
          this.$apollo.mutate({
            mutation: DataServices.updateData('users'),
            variables: {
              'data_update': {
                'avatar': objects
              },
              'where_key': {
                'id': {'_eq': userID}
              }
            }
          }).then(() => {
            // console.log('UPDATE AVATAR THANH CONG')
          }).catch((error) => {
            console.error('ERROR: ', error)
          })
        }
      }
    },
    async deleteAvatar(s3client) {
      for (let i = 0; i < this.oldImages.length; i++) {
        let fileName = this.oldImages[i].name
        await s3client.deleteFile(fileName)
      }
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('post', {"fields" : 
          `id type title caption active participation_fee currency_code number_of_mercenary number_recruit gender schedule abbout_club about_yourself age country_id attendance_check tag
          match{
            id date_time gender number_of_player_id participation_fee currency_code statdium_id 
            number_of_player{id code} 
            stadium{id name}
            competition_clubs{id club_name} name_club_competition competition_clubs_id
          } 
          clubs{id club_name}
          post_operating_time{operating_time {id operating_time_lang(where: {lang: {_eq: "en"}}){lang name}}}
          post_main_area{id province_id district_id province{id province_lang(where: {lang: {_eq: "en"}}){name}} district{id district_lang(where: {lang: {_eq: "en"}}){name}}}
        `}),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      // console.log("datadata:",data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var type_image = ""
        if(this.models.type =='POST_ON_MY_CLUB'){
          type_image = 'IMAGE_POST_MY_CLUB'
        }else if(this.models.type =='LOOKING_FOR_A_TEAM' || this.models.type =='LOOKING_FOR_MERCENARY' || this.models.type =='SCOUT_CLUB_TEAM_MEMBER' || this.models.type =='APPLYING_TO_JOIN'){
          type_image = 'IMAGE_POST_THE_MATCH'
        }else if(this.models.type =='MATCH' || this.models.type =='LIFE' || this.models.type =='SHOWING_OFF_YOUR_EQUIPMENT' || this.models.type =='QUESTION'){
          type_image = 'IMAGE_POST_COMMUNITY'
        }
        var {listData} = await this.$CoreService.getFile(type_image,this.models.id,0);
        if (listData.length > 0){
          var img_club = []
          for (let i = 0; i < listData.length; i++) {
            img_club.push({id : listData[i].id,url : listData[i].url})
          }
          this.models.img_club = listData
        }
      }
      this.componentKey++;
    },

  },
  apollo: {
    // categories: {
    //   query() {
    //     return DataServices.getList('category', {"fields" : "id name"});
    //   },
    //   update(data) {
    //     return data[Object.keys(data)];
    //   },
    //   fetchPolicy: "network-only"
    // },
    // users: {
    //   query() {
    //     return DataServices.getList('users', {"fields" : "id fullname phone"});
    //   },
    //   update(data) {
    //     return data[Object.keys(data)];
    //   },
    //   fetchPolicy: "network-only"
    // }
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ 
    /* padding: 24px; */
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18% !important;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 20px; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
<style>
.list-group-v {
  /* display: -webkit-box;
   display: -ms-flexbox;*/
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /*-ms-flex-direction: column;*/
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item-v:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.list-group-item-v {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125) ;
  height: 50px;
}
.box-check-box{
  position: relative;
}
.box-check-box label{
  position: absolute;
  left: 0px;
  top: 2px;
}
.box-check-box .check-box-day{
  position: absolute;
  right: 0px;
  top: 2px;
}
.p-field{
  margin-bottom: 0.5rem!important;
}
</style>